'use strict';

angular.module('clientDashboardApp').directive('newListing', function ($log) {
  return {
    restrict: 'A',
    scope: {
      dateAdded: '='
    },
    replace: false,
    template: '<span class="badge badge-pill badge-success" ng-if="isNewListing" uib-tooltip="Added on {{dateAdded | date:\'shortDate\'}}">NEW!</span>',
    link: function (scope, elem, attrs, ctrl) {
      if (!scope.dateAdded) {
        $log.warn('Invalid date added:' + scope.dateAdded);
        return;
      }
      var dateAdded = new Date(scope.dateAdded);
      var currDate = new Date();
      var thirtyDaysAgo = currDate.setDate(currDate.getDate() - 30);

      scope.isNewListing = dateAdded > thirtyDaysAgo;
    }
  }
});
